<div class="form-group row mt-4">
    <div class="col-md-12 mb-4">
        <div class="form-check">
            <input type="checkbox" class="form-check-input" id="aceiteTermos" name="aceiteTermos"
                [(ngModel)]="aceitouTermos" #aceiteTermosModel="ngModel" [required]="true" />

            <label class="form-check-label" for="aceiteTermos">
                Li e concordo com os
                <a href="https://www.prodigius.com.br/termosdeuso" target="_blank">{{
                    "TermosUso" | localize }}</a> e
                <a href="https://www.prodigius.com.br/privacidade" target="_blank">{{ "PoliticaPrivacidade" | localize
                    }}</a>
            </label>

            <abp-validation-summary [control]="aceiteTermosModel" [controlEl]="aceiteTermosModel"
                [customValidationErrors]="{ required: 'É necessário aceitar os termos para continuar.' }">
            </abp-validation-summary>

        </div>
    </div>
</div>